import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import {thunk} from 'redux-thunk';  // Correct import for thunk middleware
import session from './session';
import bibleReducer from './bibleSlice';  // Ensure these are correctly named
import notesReducer from './notesSlice';
import highlightReducer from './highlightSlice';
import sermonReducer from '../store/sermonSlice';
import bookmarkReducer from './bookmarkSlice';
import settingsReducer from './settingsSlice';
import devotionReducer from './devotionSlice';

const rootReducer = combineReducers({
  session,           // Managing user session state
  bible: bibleReducer,  // Bible state
  notes: notesReducer,  // Notes state
  highlight: highlightReducer,  //Hightlight state
  sermons: sermonReducer,
  bookmarks: bookmarkReducer,
  settings: settingsReducer,
  devotions: devotionReducer
});

let enhancer;

if (process.env.NODE_ENV === 'production') {
  enhancer = applyMiddleware(thunk);  // Only apply thunk in production
} else {
  const logger = require('redux-logger').default;  // Logger for development
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;  // Redux DevTools for development
  enhancer = composeEnhancers(applyMiddleware(thunk, logger));  // Apply both thunk and logger
}

const configureStore = (preloadedState) => {
  return createStore(rootReducer, preloadedState, enhancer);  // Create store with root reducer and middleware
};

export default configureStore;
